import BookFreeClassBtn from '@components/common/book-free-class-btn'
import useResolution from '@hooks/useResolution'
import classNames from 'classnames'
import { useEffect } from 'react'

type Props = {
  hideBtn?: boolean
  urlQuery?: string
  isCoursePage?: boolean
}

const FixedMobileCTA = ({ hideBtn, urlQuery, isCoursePage }: Props) => {
  const {
    dimensions: { width },
  } = useResolution()
  useEffect(() => {
    window.Atlas?.call('update', {
      chat: {
        showBubble: true,
        hideBubble: false,
        position: 'bottomRight',
        offset:
          hideBtn && width < (isCoursePage ? 1024 : 768) ? [20, 70] : [20, 20],
      },
    })
  })
  return (
    <div
      className={classNames(
        'flex fixed w-full bottom-0 left-0 items-center space-x-4 bg-white p-4 py-2 transition-opacity',
        isCoursePage ? 'lg:hidden' : 'md:hidden',
        hideBtn ? 'opacity-100' : 'opacity-0 pointer-events-none'
      )}
      style={{
        boxShadow: '0px -4px 10px rgba(0, 0, 0, 0.1)',
        zIndex: 21,
        // ponytail: forces its own compositor layer so WebKit (iOS
        // Safari/Chrome) recomputes this fixed element against the live
        // viewport when the browser's bottom toolbar shows/hides, instead of
        // leaving it rendered against a stale, larger viewport for a moment.
        // Not reproducible/verifiable in Chromium; escalate to a
        // visualViewport-driven JS reposition if this doesn't hold on device.
        transform: 'translateZ(0)',
      }}
    >
      <BookFreeClassBtn
        className="h-full"
        query={urlQuery}
        size="lg"
        tabIndex={hideBtn ? 0 : -1}
        aria-hidden={!hideBtn}
      />
    </div>
  )
}
export default FixedMobileCTA
